import { defineMessages } from 'react-intl';

export default defineMessages({
  guests: {
    id: 'filters.guests',
    defaultMessage: '{count, plural, one {1 guest} other {{count} guests}}',
  },
  activities: {
    id: 'filters.activities',
    defaultMessage: 'Activities ({count})',
  },
  defaultMessage: {
    id: 'filters.default',
    defaultMessage: '{value}',
  },
});
